<template>
    <v-dialog
        :value="isOpen"
        scrollable
        max-width="750px"
        transition="slide-y-transition"
        eager
        @keydown.esc="onClose"
        @click:outside="onClose"
    >
        <v-card>
            <v-card-title>
                <h1 class="text-subtitle-1">
                    Powiązanie zamówienia z kampanią
                </h1>
            </v-card-title>

            <v-card-text class="text-center">
                <v-container fluid class="pa-0">
                    <v-row>
                        <v-col cols="12" md="8">
                            <v-text-field
                                v-model="filters.productionNumber"
                                append-icon="mdi-magnify"
                                label="Numer zamówienia"
                                single-line
                                clearable
                                solo
                                dense
                                hide-details
                                @keyup.enter="changeFilter()"
                                @click:append="changeFilter()"
                                @click:clear="clearFilter('productionNumber')"
                            />
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="12">
                            <v-data-table
                                :items="campaignOrdersToLink"
                                :headers="headers"
                                item-key="id"
                                :mobile-breakpoint="0"
                                :footer-props="footerProps"
                                :server-items-length="pagination.itemsLength"
                                :page.sync="pagination.page"
                                :items-per-page.sync="pagination.itemsPerPage"
                                :loading="actionLoading"
                                @pagination="updatePagination"
                            >
                                <template #item.productionNumber="{item}">
                                    {{ item.productionNumber }}
                                </template>
                                <template #item.name="{item}">
                                    {{ item.name }}
                                </template>
                                <template #item.jobNumber="{item}">
                                    {{ item.jobNumber }}
                                </template>
                                <template #item.actions="{item}">
                                    <div class="d-inline-flex">
                                        <v-tooltip :open-delay="tooltipDelay" top>
                                            <template #activator="{on}">
                                                <v-btn
                                                    icon
                                                    data-sentry-label="Otwórz"
                                                    v-on="on"
                                                    @click="joinOrderToCampaign(item.id)"
                                                >
                                                    <v-icon color="teal">
                                                        mdi-exit-to-app
                                                    </v-icon>
                                                </v-btn>
                                            </template>
                                            <span>Utwórz</span>
                                        </v-tooltip>
                                    </div>
                                </template>
                            </v-data-table>
                        </v-col>
                    </v-row>
                </v-container>
            </v-card-text>
            <v-card-actions>
                <v-btn
                    color="error"
                    text
                    data-sentry-label="Zamknij"
                    :disabled="actionLoading"
                    @click="onClose"
                >
                    Zamknij
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>

import tooltipDelay from '@/mixins/tooltip'
import pagination from '@/mixins/dataTablePagination'
import filters from '@/mixins/dataTableFilters'

export default {
    name: 'JoinOrderToCampaignDialog',
    mixins: [ 
        tooltipDelay,
        filters,
        pagination,
    ],
    props: {
        isOpen: {
            type: Boolean
        },
        campaignId: {
            type: Number,
            required: true
        }
    },
    data() {
        return {
            campaignOrdersToLink: [],
            actionLoading: false,
            headers: [
                {
                    text: 'Numer zamówienia',
                    align: 'center',
                    sortable: true,
                    value: 'productionNumber'
                },
                {
                    text: 'Nazwa zamówienia',
                    align: 'center',
                    sortable: false,
                    value: 'name'
                },
                {
                    text: 'Numer zlecenia',
                    align: 'center',
                    sortable: false,
                    value: 'jobNumber'
                },
                {
                    text: 'Akcje',
                    align: 'center',
                    sortable: false,
                    value: 'actions'
                }
            ],
        }
    },
    computed: {
        footerProps() {
            return {
                itemsPerPageOptions: [5, 10, 15],
            }
        },
        filterQuery() {
            const filters = this.filters
            let query = ''

            for (let item in filters) {
                if (filters[item] != null && filters[item] != '') {
                    query = query.concat('&', `${item}=${filters[item]}`)
                }
            }

            return query
        }
    },
    watch: {
        isOpen(val) {
            if (val) {
                this.getCampaignOrdersToLink()
            }
        }
    },
    mounted() {
        this.setDefaultPagination()
    },
    methods: {
        updatePagination(pagination) {
            this.pagination = pagination

            if (pagination.pageCount !== 0 && !this.paginationSettings.paginationPending) {
                this.getCampaignOrdersToLink()
            }
            this.clearPaginationPending()
        },
        getCampaignOrdersToLink() {
            this.$store.dispatch('orders/getCampaignOrdersToLink', {
                paginate: this.paginate(),
                query: this.filterQuery
            })
                .then((response) => {
                    this.handlePaginationResponse(response)
                    this.campaignOrdersToLink = response.data.results
                })
        },
        joinOrderToCampaign(id) {
            this.actionLoading = true
            this.$store.dispatch('campaigns/joinOrderToCampaign', {
                orderId: id,
                campaignId: this.campaignId
            })
                .then(() => {
                    this.onSuccess()
                    this.onClose()
                })
                .finally(() => {
                    this.actionLoading = false
                })
        },
        changeFilter() {
            this.getCampaignOrdersToLink()
        },
        setDefaultPagination() {
            this.resetPagination()
            this.pagination.itemsPerPage = this.footerProps.itemsPerPageOptions[0]
        },
        onSuccess() {
            this.$emit('on-success')
        },
        onClose() {
            setTimeout(() => {
                this.setDefaultPagination()
            }, 300)
            this.$emit('on-close')
        }
    }
}
</script>
